const getCardBackroundImageStyles = (url: string, hasBackgroundImage: boolean) => {
  if (!hasBackgroundImage || !url) {
    return {};
  }

  return {
    backgroundImage: `url(${url})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    height: '100%',
    width: '100%',
  };
};

export default getCardBackroundImageStyles;
